import React from 'react';
import './main.css';
import { Grid, Typography } from '@material-ui/core';
import AppearingElement from "../Helper/AppearingElement";
import create from "../images/Create.png";
import play from "../images/Play.png";
import analyze from "../images/Analyze.png";

class Statistics extends React.Component {
    render() {
        return (
            <div className="stats-app">
                <Typography variant="h3" className="stats__title-app"> Don’t just navigate the terrain...Enjoy the ride!</Typography>
                <Grid container className="stats__container-app">
                    <Grid item xs={12} sm={4} md={4}>
                        <AppearingElement variant={'zoom-up'} threshold={0.1}>
                            <Typography variant="h4" className="stats__column-title-app">CREATE</Typography>
                            <div className="stats__stat-container">
                                <img alt="CREATE" src={create} className="stats__stat-app" />
                            </div>
                            <ul className="stats__bullet-app">
                                <li>
                                    <Typography variant="body1" className="stats__text-app">Create rich, interactive, step-by-step experiences on top of your business applications and processes to navigate and guide your users/employees.  No Coding Necessary! </Typography>
                                </li>
                            </ul>
                        </AppearingElement>
                    </Grid>
                    <Grid item xs={12} sm={4} md={4}>
                        <AppearingElement variant={'zoom-up'} threshold={0.1}>
                            <Typography variant="h4" className="stats__column-title-app">PLAY</Typography>
                            <div className="stats__stat-container-app">
                                <img alt="PLAY" src={play} className="stats__stat-app" />
                            </div>
                            <ul className="stats__bullet-app">
                                <li>
                                    <Typography variant="body1" className="stats__text-app">Ziplyne allows you to deliver a virtual, personalized experience to your users/employees as they navigate through the underlying business application.</Typography>
                                </li>
                            </ul>
                        </AppearingElement>
                    </Grid>
                    <Grid item xs={12} sm={4} md={4}>
                        <AppearingElement variant={'zoom-up'} threshold={0.1}>
                            <Typography variant="h4" className="stats__column-title-app">ANALYZE</Typography>
                            <div className="stats__stat-container-app">
                                <img alt="ANALYZE" src={analyze} className="stats__stat-app" />
                            </div>
                            <ul className="stats__bullet-app">
                                <li>
                                    <Typography variant="body1" className="stats__text-app">Ziplyne enables you to quickly and effectively identify where users/employees are in need of additional guidance. Consequently, providing targeted retraining/support for your employees and maximizing the ROI of your digital software investments is easier than ever.</Typography>
                                </li>
                            </ul>
                        </AppearingElement>

                    </Grid>
                    {/* <Grid item xs={6} sm={6} md={3}>
                        <AppearingElement variant={'zoom-up'}>
                            <div className="stats__stat-container">
                                <Typography variant="h4" className="stats__stat">box 4</Typography>
                            </div>
                            <ul className="stats__bullet">
                                <li>
                                    <Typography variant="body1" className="stats__text">box 4 stat description</Typography>
                                </li>
                            </ul>
                        </AppearingElement>

                    </Grid> */}
                </Grid>
            </div>
        )
    }
}
export default Statistics